import { FIELD_TYPES, LINE_HEIGHT } from "./constants";
import { convertISO8601toDayFirstFormat } from "../../../../common/utils";

export const displayValue = (value, criteriaType) => {
	if (FIELD_TYPES.DATE === criteriaType) {
		return convertISO8601toDayFirstFormat(value);
	}
	return value;
};

export const maxCollapseHeight = (lines) => lines * LINE_HEIGHT;
